import type { AssetsBatchEditAssetTypeProps } from "./assets-batch-edit-asset-type.type";

import { useTranslation } from "react-i18next";

import { AssetTypeSelect } from "@/modules/asset-type/asset-type-select";
import BatchEditForm from "@/modules/batch-edit-form";

import { AssetsBatchEditAssetTypeAlert } from "./assets-batch-edit-asset-type-alert";
import {
  useAssetsBatchEditAssetType,
  useAssetsBatchEditAssetTypeAlert,
} from "./assets-batch-edit-asset-type.hook";

export const AssetsBatchEditAssetType = ({
  assets,
}: AssetsBatchEditAssetTypeProps) => {
  const { t } = useTranslation();

  const {
    form,
    formValue,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    isPending,
    hasChanges,
    hasError,
    fieldApiError,
  } = useAssetsBatchEditAssetType(assets);

  const {
    setAssetTypeId,
    isAssetTypeLoading,
    showAssetTypeAlert,
    concernedAssets,
  } = useAssetsBatchEditAssetTypeAlert(assets);

  return (
    <BatchEditForm
      modelKey="asset"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
      disabled={!formValue} // disable form when no asset type selected
    >
      <AssetTypeSelect
        name={fieldName}
        label={t("asset:batchEdit.assetType.label")}
        placeholder={t("global:assetType")}
        rules={[{ required: true }]}
        loading={isAssetTypeLoading}
        onChange={(id) => setAssetTypeId(id)}
        validateStatus={fieldApiError ? "error" : "success"}
        help={fieldApiError}
      />
      {showAssetTypeAlert && (
        <AssetsBatchEditAssetTypeAlert
          assets={assets}
          concernedAssets={concernedAssets}
        />
      )}
    </BatchEditForm>
  );
};
